const rad = (d) => (Number(d) || 0) * Math.PI / 180;

export default function drawSquare(g, _app, { origin, settings }) {
  const ppm = Number(settings?.pxPerMeter) || 40;
  const toPx = (m) => Math.max(0, Number(m) || 0) * ppm;

  try { g.lineStyle({ width: 2, color: 0x00d4ff, alpha: 1 }); }
  catch { g.lineStyle(2, 0x00d4ff, 1); }

  const w = Math.max(2, toPx(settings?.width  ?? 2));
  const h = Math.max(2, toPx(settings?.height ?? 2));
  const R = rad(settings?.rotationDeg || 0);
  const hw = w / 2, hh = h / 2;

  const pts = [
    { x: -hw, y: -hh }, { x:  hw, y: -hh },
    { x:  hw, y:  hh }, { x: -hw, y:  hh },
  ].map(p => ({
    x: origin.x + p.x * Math.cos(R) - p.y * Math.sin(R),
    y: origin.y + p.x * Math.sin(R) + p.y * Math.cos(R),
  }));

  g.moveTo(pts[0].x, pts[0].y);
  for (let i = 1; i < pts.length; i++) g.lineTo(pts[i].x, pts[i].y);
  g.lineTo(pts[0].x, pts[0].y);
}
